/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import type { ContentStackProductFinder } from '../../interface/content-types';

export type ProductFinder = {
  product_finder: {
    product_finder?: ContentStackProductFinder[];
  };
};

export const isProductFinder = (item: unknown): item is ProductFinder => {
  return Boolean(
    item &&
    typeof item === 'object' &&
    'product_finder' in item &&
    item.product_finder &&
    typeof item.product_finder === 'object' &&
    'product_finder' in item.product_finder &&
    Array.isArray(item.product_finder.product_finder),
  );
};
